export default "__VITE_ASSET__42fe04bb__"